// prettier-ignore

/**
 * Zip code regex provided by Shopland.
 */
export const ZIP_CODE_BY_COUNTRY_REGEX: { [key: string]: RegExp } =  {
  US: /^[0-9]{5}(\-[0-9]{4})?$/i,
  GB: /^(GIR|[A-Z]\d[A-Z\d]??|[A-Z]{2}\d[A-Z\d]??)[ ]??(\d[A-Z]{2})$/i,
  CA: /^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ])\ {0,1}(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/i,
  DE: /\b((?:0[1-46-9]\d{3})|(?:[1-357-9]\d{4})|(?:[4][0-24-9]\d{3})|(?:[6][013-9]\d{3}))\b/,
  FR: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/i,
  IT: /^(V-|I-)?[0-9]{5}$/i,
  AU: /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/,
  NL: /^[1-9][0-9]{3}\s?([a-zA-Z]{2})?$/i,
  ES: /^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/,
  BE: /^[1-9]{1}[0-9]{3}$/,
  IN: /^\d{6}$/,
  INTL: /^[a-z0-9\s\-]+$/i
}
